<h3 class="eb-quick-order__title">{{ 'quickOrder.title' | cxTranslate }}</h3>
<eb-spinner *ngIf="loading$ | async" class="eb-quick-order__spinner"></eb-spinner>
<div [formGroup]="quickOrderForm" class="eb-quick-order" [class.loading]="loading$ | async">
  <ng-container formArrayName="quickOrderItems">
    <ng-container *ngFor="let quickOrderItemForm of quickOrderItems.controls; let i = index">
      <div
        [formGroup]="quickOrderItemForm"
        (keydown.enter)="addToCart()"
        class="eb-quick-order__quick-add-item-row"
      >
        <div class="eb-quick-order__quick-add-item-first-col">
          <label for="articleNumber" class="eb-form__field-label-content">
            <span *ngIf="i === 0">{{ 'cartItems.articleNumber.name' | cxTranslate }}</span>
            <input
              id="articleNumber"
              type="text"
              class="form-control"
              [attr.error]="quickOrderItemForm.value?.error"
              [formControl]="convertToFormControl(quickOrderItemForm.get('articleNumber'))"
            />
            <span *ngIf="quickOrderItemForm.value?.error" class="eb-form__field-label-error">
              {{ getErrorMessageKey(quickOrderItemForm.value?.error) | cxTranslate }}</span
            >
          </label>
        </div>
        <label for="quantity" class="eb-form__field-label-content">
          <span *ngIf="i === 0">{{ 'cartItems.quantity' | cxTranslate }}</span>
          <eb-item-counter
            [max]="maxQuantity"
            id="quantity"
            [control]="convertToFormControl(quickOrderItemForm.get('quantity'))"
            [pushMatomoEvents]="false"
          ></eb-item-counter>
        </label>
      </div>
    </ng-container>
    <div class="eb-quick-order__actions">
      <div class="eb-quick-order__quick-add-item-first-col">
        <button
          data-cy="add-new-line"
          class="eb-quick-order__add-quick-order-item"
          (click)="addQuickOrderItem()"
        >
          {{ 'quickOrder.addItem' | cxTranslate }}
          <em class="fas fa-plus"></em>
        </button>
      </div>
      <button
        type="submit"
        [disabled]="!isAnyArticleNumberValid()"
        class="eb-quick-order__add-to-cart"
        (click)="addToCart()"
      >
        {{ 'quickOrder.addToCart' | cxTranslate }}
        <em class="fas fa-cart-plus"></em>
      </button>
    </div>
  </ng-container>
</div>

<ng-template #spinner>
  <eb-spinner></eb-spinner>
</ng-template>
